import { CSSProperties, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListOl } from "@fortawesome/free-solid-svg-icons/faListOl";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { AXNUIFormContentSlotContentTypes } from "@iddataweb/idw-common-ui/enums";
import styles from "./sortable-form-content-slot-content-types-container.less";
import { PLACEHOLDER_BORDER_STYLE } from "@constants/dnd-constants";
import { SortableDndItem } from "@containers/common/sortable-dnd-container/sortable-dnd-item/sortable-dnd-item";
import { SortableDndContainer } from "@containers/common/sortable-dnd-container/sortable-dnd-container";
import { DragEndEvent } from "@dnd-kit/core";

type SortableFormContentSlotContentTypesContainerProps = {
    isDisabled: boolean;
    order: Array<string>;
    mappedOrder: Array<string>;
    formContentSlotType: string;
    setOrder: (order: Array<string>) => void;
};

export const SortableFormContentSlotContentTypesContainer = (props: SortableFormContentSlotContentTypesContainerProps) => {
    const { isDisabled, order, mappedOrder, setOrder } = props;
    const [dndActiveId, setDndActiveId] = useState(null);
    const dndItemStyle : CSSProperties = {
        userSelect: "none",
        padding: "0.5rem",
        display: "flex",
        alignItems: "center"
    };
    const handleDragEnd = (event: DragEndEvent) => {
        const { active, over } = event;
        if (active.id !== over.id) {
            const oldIndex = active.data.current.sortable.index;
            const newIndex = over.data.current.sortable.index;
            const newContentTypes = [...order];
            const movedContentType = newContentTypes.splice(oldIndex, 1)[0];
            newContentTypes.splice(newIndex, 0, movedContentType);

            setOrder(newContentTypes);
        }
    };

    const removeContentSlotContentType = (contentTypeToRemove: AXNUIFormContentSlotContentTypes) => {
        const newOrder = order.filter(contentType => contentType !== contentTypeToRemove);
        setOrder(newOrder);
    };

    const contentSlotValues = useMemo(() => {
        return order.map(contentType => contentType);
    }, [order]);

    const contentSlotElements: Array<(shouldApplyPlaceholder: boolean, activeId?: string) => React.ReactNode> = useMemo(() => {
        return order.map((contentType: AXNUIFormContentSlotContentTypes, index) => (
            (shouldApplyPlaceholder: boolean, activeId: string) =>
            (<SortableDndItem
                key={contentType}
                showDragAndDropIcon={false}
                id={contentType}
                isActiveId={shouldApplyPlaceholder && activeId === contentType}
                additionalStyle={dndItemStyle}
                activeIdStyle={{ ...dndItemStyle, ...PLACEHOLDER_BORDER_STYLE }}
            >
                <>
                    <span>
                        <FontAwesomeIcon className={styles.listIcon} icon={faListOl} />{index + 1}. {mappedOrder[index]}
                    </span>
                    {!isDisabled && (
                        <span className={styles.removeIconContainer} onClick={() => removeContentSlotContentType(contentType)}>
                            <FontAwesomeIcon className={styles.removeIcon} icon={faTimesCircle} />
                        </span>
                    )}
                </>
            </SortableDndItem>)
        ));
    }, [order, mappedOrder, isDisabled]);

    return (
        <div className={styles.sortableFormContentSlotContentTypesContainer}>
            <SortableDndContainer
                isDisabled={isDisabled}
                useDragOverlay={true}
                internalDragAndDropElements={contentSlotElements}
                internalDragAndDropElementsValues={contentSlotValues}
                styles={{ position: "relative", border: "1px solid #dee2e6" }}
                handleDragEnd={handleDragEnd}
                activeId={dndActiveId}
                setActiveId={setDndActiveId}
            />
        </div>
    );
};